import CheckIcon from '@mui/icons-material/Check';

export const CheckedBorder = () => {
  return (
    <>
      <div
        style={{
          width: 0,
          height: 0,
          borderStyle: 'solid',
          borderWidth: '0 30px 30px 0',
          borderColor: 'transparent #B484FF transparent transparent',
          right: 0,
          top: 0,
          position: 'absolute',
        }}
      />
      <CheckIcon
        fontSize="small"
        sx={{ right: '-2px', top: 0, position: 'absolute', color: '#fff', fontSize: '1.2rem' }}
      />
    </>
  );
};
